var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCostModel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 11.667V12.8338M7 1.1662V2.33296M9.9169 11.667V12.8338M9.9169 1.1662V2.33296M1.1662 7H2.33296M1.1662 9.9169H2.33296M1.1662 4.0831H2.33296M11.667 7H12.8338M11.667 9.9169H12.8338M11.667 4.0831H12.8338M4.0831 11.667V12.8338M4.0831 1.1662V2.33296M3.49972 2.33296H10.5003C11.1447 2.33296 11.667 2.85534 11.667 3.49972V10.5003C11.667 11.1447 11.1447 11.667 10.5003 11.667H3.49972C2.85534 11.667 2.33296 11.1447 2.33296 10.5003V3.49972C2.33296 2.85534 2.85534 2.33296 3.49972 2.33296ZM5.24986 4.66648H8.75014C9.07233 4.66648 9.33352 4.92767 9.33352 5.24986V8.75014C9.33352 9.07233 9.07233 9.33352 8.75014 9.33352H5.24986C4.92767 9.33352 4.66648 9.07233 4.66648 8.75014V5.24986C4.66648 4.92767 4.92767 4.66648 5.24986 4.66648Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostModel);
export default __webpack_public_path__ + "static/media/costModel.2c0ffb9732cb5fcf1e05ba6c44b56236.svg";
export { ForwardRef as ReactComponent };